const DEBUG = import.meta.env.DEV;

export const debug = {
  log: (...args: any[]) => DEBUG && console.log(...args),
  error: (...args: any[]) => console.error(...args),
  warn: (...args: any[]) => DEBUG && console.warn(...args),
};
